import BaseSiteFactorData from './BaseSiteFactorData'
import DataFormatter from '../model/DataFormatter'
// import Constant from '../model/Constant'

// const {DAS_FLAG_MAP} = Constant

export default {
  extends: BaseSiteFactorData,
  methods: {
    format (currentQuery, otherDimensionProp, formatter, oDataListProp, dataListProp) {
      let {dimension} = this
      let otherDimension = dimension ^ 1

      let dimensionIdProps = new Array(2)
      dimensionIdProps[dimension] = 'siteId'
      dimensionIdProps[otherDimension] = otherDimensionProp
      let [dimensionIdProp0, dimensionIdProp1] = dimensionIdProps

      let dimensionIds = new Array(2)
      dimensionIds[dimension] = currentQuery.siteIds
      dimensionIds[otherDimension] = currentQuery.factorIds
      let [dimensionIds0, dimensionIds1] = dimensionIds

      let {siteFactorMap, factorSiteMap} = this
      let dimensionObjects = new Array(2)
      dimensionObjects[dimension] = siteFactorMap
      dimensionObjects[otherDimension] = factorSiteMap
      let dimensionObjectMap = dimensionObjects[0]

      let tmpList = this[oDataListProp]
      let {completeAllData} = this
      let beginTS = new Date(currentQuery.beginTime).getTime()
      let dataList = Object.values(tmpList.reduce((map, data) => {
        let newData = map[data[dimensionIdProp0]]

        if (newData) {
          let {dataTime} = data
          let ts = new Date(dataTime).getTime()

          if (ts > newData.endTS) {
            newData.endTS = ts
          }

          formatter(data, newData, dimensionIdProp1, ts, dataTime)
        }

        return map
      }, dimensionIds0.reduce((map, dimensionId) => {
        let dimensionObject = dimensionObjectMap[dimensionId]
        let subDimensionMap = dimensionObject.map
        let seriesDimensions = dimensionIds1.reduce((list, id) => {
          let dimensionObj = subDimensionMap[id]

          if (dimensionObj) {
            list.push(dimensionObj)
          }

          return list
        }, [])

        map[dimensionId] = {
          id: dimensionId,
          name: dimensionObject.name,
          beginTS,
          endTS: completeAllData ? new Date(currentQuery.endTime).getTime() : beginTS,
          dimensions: seriesDimensions,
          selectedNames: dimensionObject.selectedNames,
          seriesMap: seriesDimensions.reduce((map, seriesDimension) => {
            map[seriesDimension.id] = []
            return map
          }, {})
        }

        return map
      }, {})))

      let {unitProp} = this
      let data = Object.freeze(DataFormatter[`completeAndUnitConvert${currentQuery.dataType}`](dataList, unitProp))
      this.totalDataTimes = Object.freeze(data.totalDataTimes)
      this[dataListProp] = Object.freeze(data.dataList)
    },
    formatData () {
      console.time('format2')

      let {currentQuery, valueProp} = this

      if (Object.keys(currentQuery).length === 0) {
        return
      }

      const {filterSiteMap} = this
      // const auditRuleFlagMap = {...(this.auditRuleFlagMap || {}), N: {name: '正常'}, X: {name: '数采标记异常'}}
      this.tmpList = Object.freeze(this.tmpList.concat(Object.values(this.noDataReasonMap).reduce((list, noDataReason) => {
        const {siteId} = noDataReason
        const siteConfig = filterSiteMap[siteId]

        if (siteConfig) {
          const {siteDeviceId} = noDataReason
          const siteDeviceConfig = siteConfig.devices.find(siteDevice => siteDevice.id === siteDeviceId)

          if (siteDeviceConfig) {
            const {reason} = noDataReason
            const dataTime = `${noDataReason.dataTime}:00:00`
            siteDeviceConfig.siteDeviceFactors.forEach((siteDeviceFactor) => {
              list.push({
                dataTime,
                siteId,
                siteDeviceId,
                factorId: siteDeviceFactor.factorId,
                auditComment: reason,
                isAuditCompleted: true
              })
            })
          }
        }

        return list
      }, [])).sort((a, b) => a.dataTime.localeCompare(b.dataTime)))

      const queryIsAuditCompleted = currentQuery.isAuditCompleted
      const auditType = (queryIsAuditCompleted + 1) | (-currentQuery.isFuse & 3)

      this.format.bind(this)(currentQuery, 'factorId', (data, newData, dimensionIdProp1, ts, dataTime) => {
        let value = data[valueProp]
        let series = newData.seriesMap[data[dimensionIdProp1]]

        if (series) {
          const displayFlags = []

          /** begin: 1 */
          // if (data.isHaveIntegral) {
          //   displayFlags.push('重积分')
          // } else if (Number.isFinite(value)) {
          //   const {dasFlag, flag} = data
          //   displayFlags.push(DAS_FLAG_MAP[dasFlag] || dasFlag)

          //   if (flag) {
          //     displayFlags.push(flag.split('|').map(flag => {
          //       const flagRule = auditRuleFlagMap[flag]
          //       return flagRule ? flagRule.name : flag
          //     }).join('|'))
          //   }
          // }

          // if (data.isAuditCompleted && (this.currentQuery.isAuditCompleted || this.currentQuery.isFuse)) {
          //   const {auditComment} = data

          //   if (auditComment) {
          //     displayFlags.push(auditComment)
          //   }
          // }
          /** end: 1 */

          /** begin: 2 */
          // const bin = auditType & (data.isAuditCompleted + 1)
          // const {isHaveIntegral} = data

          // if (bin === 2) {
          //   if (isHaveIntegral) {
          //     displayFlags.push('重积分')
          //   }

          //   const {auditComment} = data

          //   if (auditComment) {
          //     displayFlags.push(auditComment)
          //   }
          // } else if (bin === 1) {
          //   if (isHaveIntegral) {
          //     displayFlags.push('重积分')
          //   } else {
          //     displayFlags.push(data.dasFlag)
          //   }
          // }
          /** end: 2 */

          /** begin: 3 */
          const isAuditCompleted = (!!data.isAuditCompleted) + 1
          const bin = auditType & isAuditCompleted

          if (queryIsAuditCompleted === false || bin === 1) {
            if (data.isHaveIntegral) {
              displayFlags.push('')
            } else {
              displayFlags.push(data.dasFlag)
            }
          } else if (bin === 2) {
            const {value} = data

            if (Number.isFinite(value)) {
              const {auditFlag} = data

              if (auditFlag) {
                displayFlags.push(auditFlag === 'DELETE' ? 'O' : 'R', data.auditComment)
              }
            } else {
              displayFlags.push(data.auditComment)
            }
          }
          /** end: 3 */

          const newDataItem = {
            ...data,
            ts,
            dataTime,
            isHaveIntegral: data.isHaveIntegral || false,
            flag: data.flag || null,
            dasFlag: data.dasFlag || null,
            auditFlag: data.auditFlag,
            // displayFlag: displayFlags.join(',')
            displayFlags
          }

          if (bin === 2 && data.auditFlag === 'DELETE') {
            delete newDataItem.value
            newDataItem.noDataReason = newDataItem.auditComment
          } else if (Number.isFinite(value)) {
            newDataItem.value = value
          } else {
            newDataItem.noDataReason = newDataItem.auditComment || ''
          }

          series.push(newDataItem)
        }
      }, 'tmpList', 'dataList')

      console.timeEnd('format2')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/YaoBaseSiteFactorData.js